/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ChatStatisticsIntervalViewModel } from "../types/ChatStatisticsIntervalViewModel.ts";

export const chatStatisticsIntervalViewModelSchema = z.object({
  userQuantity: z.optional(z.number().int()),
  date: z.optional(z.string().datetime()),
  activePercentage: z.string().nullish(),
}) as unknown as ToZod<ChatStatisticsIntervalViewModel>;
